import {ActionTypes} from "../contants/action-type.js";
import {
    getAllOrders,
    getSelectedOrder
} from '../../services/OrderService.js';

export function getAllOrderAction() {
    return (dispatch, getState) => {
        getAllOrders().then((response) => {
            dispatch(listAllOrders(response.data));
        });
    };
}


export function getSelectedOrderAction(id) {
    return (dispatch, getState) => {
        getSelectedOrder(id).then((response) => {
            dispatch(selectedOrder(response.data));
        });
    };
}


// export function getAcceptedOrderAction(type) {
//     return (dispatch, getState) => {
//         getOrders(type).then((response) => {
//             dispatch(listAcceptedOrders(response.data));
//         });
//     };
// }
// export function getPreparedOrderAction(type) {
//     return (dispatch, getState) => {
//         getOrders(type).then((response) => {
//             dispatch(listPreparedOrders(response.data));
//         });
//     };
// }
// export function getDeliverdOrderAction(type) {
//     return (dispatch, getState) => {
//         getOrders(type).then((response) => {
//             dispatch(listDeliveredOrders(response.data));
//         });
//     };
// }
// export function getRejectedOrderAction(type) {
//     return (dispatch, getState) => {
//         getOrders(type).then((response) => {
//             dispatch(listRejectedOrders(response.data));
//         });
//     };
// }


// export function createOrderAction(cuisine, history) {
//     return (dispatch, getState) => {
//         createOrder(cuisine).then((response) => {
//             dispatch(confirmCreateOrder(response.data));
//             history.push('/item/cuisine');
//         });
//     };
// }
// export function updateOrderAction(cuisine,id, history) {
//     return (dispatch, getState) => {
//         console.log(cuisine);
//         updateOrder(cuisine,id).then((response) => {
//             dispatch(confirmEditOrder(response.data));
//             history.push('/item/cuisine');
//         });
//     };
// }
// export function changeStatusOrderAction(cuisine, id, history) {
//     return (dispatch, getState) => {
//         changeStatusOrder(cuisine, id).then((response) => {
//             dispatch(listOrders(response.data));
//             history.push('/item/cuisine');
//         });
//     };
// }
// export function deleteOrderAction(id, history) {
//     return (dispatch, getState) => {
//         deleteOrder(id).then((response) => {
//             dispatch(listOrders(response.data));
//             history.push('/item/cuisine');
//         });
//     };
// }



export const listAllOrders = (allorders) => {
    return {
        type: ActionTypes.LIST_ALL_ORDER,
        payload: allorders
    }
}
export const listAcceptedOrders = (allorders) => {
    return {
        type: ActionTypes.LIST_ACCEPTED_ORDER,
        payload: allorders
    }
}
export const listPreparedOrders = (allorders) => {
    return {
        type: ActionTypes.LIST_PREPARED_ORDER,
        payload: allorders
    }
}
export const listDeliveredOrders = (allorders) => {
    return {
        type: ActionTypes.LIST_DELIVERED_ORDER,
        payload: allorders
    }
}
export const listRejectedOrders = (allorders) => {
    return {
        type: ActionTypes.LIST_REJECTED_ORDER,
        payload: allorders
    }
}

// export const confirmCreateOrder = (cuisine) => {
//     return {
//         type: ActionTypes.CONFIRM_CREATE_CUISINE,
//         payload: cuisine
//     }
// }
// export const confirmEditOrder = (cuisine) => {
//     return {
//         type: ActionTypes.CONFIRM_EDIT_CUISINE,
//         payload: cuisine
//     }
// }
export const selectedOrder = (order) => {
    return {
        type: ActionTypes.SELECTED_ORDER,
        payload: order
    }
}
// export const confirmDeleteOrder = (cuisine) => {
//     return {
//         type: ActionTypes.CONFIRM_DELETE_CUISINE,
//         payload: cuisine
//     }
// }